/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewItem_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_itemSearch" | "QuickViewCreators_itemSearch">;
    readonly " $refType": "QuickViewItem_itemSearch";
};
export type QuickViewItem_itemSearch$data = QuickViewItem_itemSearch;
export type QuickViewItem_itemSearch$key = {
    readonly " $data"?: QuickViewItem_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewItem_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewItem_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewCategoryParagraph_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewCreators_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '573356057242e7718a32bb2dfc939278';
export default node;
